import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseRequest from '@/use/usePurchaseRequest';

import { drawing_no, material_code } from '../Job/SubJob/base';

const { classMap, translate } = usePurchaseRequest();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    production_type: {
      name: 'ประเภท',
      width: '6rem',
    },
    job_no: {
      name: 'Sub Job No.',
      width: '8rem',
    },
    drawing_no,
    description: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    material_code: {
      ...material_code,
      width: '1.5fr',
    },
    neededAmount: {
      name: 'จำนวน',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    status: {
      name: 'Request Status',
      width: '8rem',
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return classMap(val, true);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val, row.item.approved);
      },
    },
    target_date: {
      name: 'Target Date',
      width: '8rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    amount: {
      name: 'จำนวนที่ต้องการซื้อ',
      width: '8rem',
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-center',
    },
    remarks: {
      name: 'หมายเหตุ',
      width: '6rem',
      class: 'text-center',
    },
  },
};
